import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { FilterValueProvider } from './Components/Context/FilterContext';
import { LocalCartContextValueProvider } from './Components/Context/LocalCartContext';
import OnlineAnalysisBootstrapper from './Components/OnlineAnalysis/OnlineAnalysisBootstrapper';
import CartIntegrations from './Integrations/CartIntegrations/CartIntegrations';
import AdditionalProductsSliderIntegration from './Integrations/FilterIntegrations/AdditionalProductsSliderIntegration';
import FilterIntegrations from './Integrations/FilterIntegrations/FilterIntegrations';
import LoginFormIntegrations from './Integrations/LoginFormIntegrations';
import VoucherIntegration from './Integrations/ProductActionsIntegrations/VoucherIntegration';
import PremiumProgramIntegration from './Integrations/ProductActionsIntegrations/PremiumProgramIntegration';
import ProductAvailabilityIntegrations from './Integrations/ProductAvailabilityIntegrations/ProductAvailabilityIntegrations';
import ProductBadgesIntegrations from './Integrations/ProductBadgesIntegrations/ProductBadgesIntegrations';
import PublicWatchlistIntegration from './Integrations/WatchAndWishlistIntegrations/PublicWatchlistIntegration';

import './Search/Search';

const LoggedOutIntegrations: React.FunctionComponent = () => {
    return (
        <>
            <FilterValueProvider>
                <LoginFormIntegrations />
                <FilterIntegrations />
                <OnlineAnalysisBootstrapper />
                <AdditionalProductsSliderIntegration />
            </FilterValueProvider>

            <ProductAvailabilityIntegrations />
            <ProductBadgesIntegrations />

            <LocalCartContextValueProvider>
                <CartIntegrations />
                <PublicWatchlistIntegration />
                <VoucherIntegration />
                <PremiumProgramIntegration />
            </LocalCartContextValueProvider>
        </>
    );
};

ReactDOM.render(<LoggedOutIntegrations />, document.querySelector('#js-dom-integrations'));
